module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_ohana-704115c62b3b59f6b49a1ecef7d46b00.jpg";